import keys from "configs/constants";
import {
  getAPICallAuthHeader,
  handleSessionRevoked,
  isAuthReady,
  isSessionRevoked,
} from "./backendService";

const callCoreIAM = async (method, endpoint, body) => {
  const url = `${keys.CORE_API_URL}/${endpoint}`;
  const result = {};
  const request = {};

  request.method = method;
  let config = await getAPICallAuthHeader();
  if (!isAuthReady(config)) return null;
  config = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type":
        method === "PATCH"
          ? "application/json-patch+json; charset=utf-8"
          : "application/json; charset=utf-8",
      "X-Origin": "Xplore",
    },
  };
  request.headers = config.headers;
  request.body = body ? JSON.stringify(body) : null;

  const response = await fetch(url, request);
  result.status = response.status;
  result.data = null;
  result.responseString = "";

  // A 401 tagged as a server-side revocation forces a sign-out; any other 401 falls through to the
  // regular error path below, exactly like any other non-ok response.
  if (response.status === 401 && isSessionRevoked(response)) {
    handleSessionRevoked();
  }

  if (!response.ok) {
    result.responseString = (
      response.statusText ||
      response.status ||
      "Unknown Error"
    ).toString();
    try {
      result.data = await response.json();
    }catch(e){}
    return Promise.reject(result);
  }
  if (response.status !== 204) {
    result.data = await response.json();
    result.responseString = (
      response.data ||
      response.statusText ||
      response.status ||
      "Unknown Error"
    ).toString();
  }
  return Promise.resolve(result.data);
};

export async function getSelfAsync() {
  return await callCoreIAM("GET", "users/me", undefined);
}

const mapKeyForPatchSettings = (key) => {
  switch (key.toString().toLowerCase()) {
    case "lang":
      return "settings/language";
    case "temp_unit":
      return "settings/temperatureUnit";
    case "press_unit":
      return "settings/pressureUnit";
    case "theme":
      return "settings/theme";
    default:
      return key;
  }
};

export async function patchSelfAsync(props) {
  const body = Object.entries(props).map(([key, value]) => ({
    op: "replace",
    path: `/${mapKeyForPatchSettings(key)}`,
    value: value,
  }));

  return await callCoreIAM("PATCH", "users/me", body);
}

const REVOKE_SESSION_TIMEOUT_MS = 3000;

// Revokes the current session server-side (blocklists this token's jti) on logout, so it can no longer
// be replayed. Best-effort: neither a failure nor a slow/unreachable core-IAM must block the sign-out,
// hence the timeout -- the user still gets signed out locally and the token expires on its own.
export async function revokeCurrentSession() {
  // The .catch() belongs on the call itself, not on the race: if the timeout wins, a rejection arriving
  // afterwards would otherwise surface as an unhandled promise rejection.
  await Promise.race([
    callCoreIAM("POST", "sessions/revoke", undefined).catch(() => null),
    new Promise((resolve) => setTimeout(resolve, REVOKE_SESSION_TIMEOUT_MS)),
  ]);
}
